import styled from 'styled-components';
import { WebsocketManager } from '../../hook/WebsocketManager';
import { HeaderButtonProvider } from '../../component/header/HeaderButtonProvider';
import Header from '../../component/header/Header';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ProductionProgress } from '../user/pages/ProductionProgress';
import { useEffect, useState } from 'react';
import { ProductionProgressWorker } from '../user/pages/ProductionProgressWorker';
import { SidebarAdmin } from '../../Sidebar/SidebarAdmin';
import { AccountManage } from './pages/AccountManage';
import { DataManage } from './pages/DataManage';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/modules';
import { SchedulerManage } from './pages/SchedulerManage';
import { Inquiries } from '../../component/popup/Inquiries';
import { useWebsocket } from '../../hook/WebsocketContext';
import {
  InquiriesItemType,
  userListGetApi,
  UserType,
} from '../../api/apiConfig';
import { addNewItem, addPrevItems } from '../../store/modules/inquiriesItem';
import { InquiriesAdmin } from '../../component/popup/InquiriesAdmin';
import useFetch from '../../api/useFetch';

export const AdminRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [users, setUsers] = useState<UserType[]>([]);

  const { fetch: fetchUserListGetApi } = useFetch({
    fetchFunction: userListGetApi,
    onSuccess: (data: UserType[]) => setUsers(data),
  });

  const { subscribe, connectSocket, isConnected } = useWebsocket();

  useEffect(() => {
    if (location.pathname === '/' || location.pathname === '/login') {
      navigate('/account-manage');
    }
  }, [location]);

  // useEffect(() => {
  //   fetchUserListGetApi();
  //   connectSocket();
  // }, []);

  // useEffect(() => {
  //   console.log('isSuperUser', isSuperUser, 'userlength', users.length);
  //   if (!isSuperUser || users.length < 1) return;
  //   connectSocketToUsers();
  // }, [isSuperUser, users]);

  // function connectSocketToUsers() {
  //   console.log('userList', users);
  //   users.forEach((user, index) => {
  //     const targetId = user.loginId;
  //     setTimeout(() => {
  //       console.log(`🔗 구독 시도: /sub/chat/${targetId}`);
  //       subscribe(`/sub/chat/${targetId}`, (message) => {
  //         console.log(`📩 새 메시지 (ID: ${targetId}):`, message);
  //         // dispatch(addNewItem(message));
  //         messageDispatcher(message.type, message.data);
  //       });
  //     }, index * 50); // 50ms 간격으로 subscribe 실행
  //   });
  // }

  // function messageDispatcher(
  //   type: 'previous' | 'new',
  //   message: InquiriesItemType[]
  // ) {
  //   console.log(type, message);
  //   if (type === 'previous') {
  //     // dispatch(addPrevItems(message));
  //   }
  //   if (type === 'new') {
  //     if (message.length !== 1) return;
  //     dispatch(addNewItem(message[0]));
  //   }
  // }

  // function loadPrevItems() {}

  const WithDefaultLayout = ({ children }: { children: React.ReactNode }) => (
    <WholeContainer>
      <WebsocketManager />
      <SidebarAdmin />
      <BodyContainer>
        <HeaderButtonProvider>
          <Header />
          <Content>{children}</Content>
        </HeaderButtonProvider>
      </BodyContainer>
    </WholeContainer>
  );

  return (
    <Routes>
      <Route
        path='account-manage'
        element={
          <WithDefaultLayout>
            <AccountManage />
          </WithDefaultLayout>
        }
      />
      <Route
        path='data-manage'
        element={
          <WithDefaultLayout>
            <DataManage />
          </WithDefaultLayout>
        }
      />
      <Route
        path='scheduler-manage'
        element={
          <WithDefaultLayout>
            <SchedulerManage />
          </WithDefaultLayout>
        }
      />
      {/* <Route
        path='inquiries'
        element={
          <WithDefaultLayout>
            <InquiriesAdmin />
          </WithDefaultLayout>
        }
      /> */}
    </Routes>
  );
};

const WholeContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
`;

const BodyContainer = styled.div`
  flex-basis: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.lightGray};
`;
